const defaultTitle = "玖龙智通管理系统";
const defaultMeta = {
  // 当前路由对应title
  title: defaultTitle,
  // 是否缓存页面
  keepAlive: false,
  // 是否显示底部Copyright
  showFoot: false,
  // 是否显示左菜单
  showLeftAside: false,
  // 权限显示
  powerList: [],
  // 对应菜单名字
  menuName: ""
};
console.log(defaultMeta);
// 解决权限问题
// 解决激活刷新问题
// 解决菜单分组问题 ok
// 每个页面都都左边菜单配置，方便统计管理，以及整体布局的调整以及优化 ok
const routes = [
  {
    path: "/",
    redirect: "/rhBigScreen"
  },
  {
    path: "/rhBigScreen",
    redirect: "/rhBigScreen/intoPage"
  },
  // 前端重定向页面
  {
    path: "/rhBigScreen/redirectPage",
    name: "rhBigScreenRedirectPage",
    component: () => import("../RedirectPage.vue")
  },
  {
    path: "/rhBigScreen/index",
    name: "rhBigScreenIndex",
    component: () => import("../Index.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/index64",
    name: "rhBigScreenIndex64",
    component: () => import("../Index64.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/index64New",
    name: "rhBigScreenIndex64New",
    component: () => import("../Index64New.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/indexTmp",
    name: "rhBigScreenIndexTmp",
    component: () => import("../IndexTmp.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/indexShipment",
    name: "rhBigScreenIndexShipment",
    component: () => import("../IndexShipment.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/indexShipmentlLeader",
    name: "rhBigScreenIndexShipmentlLeader",
    component: () => import("../IndexShipmentlLeader.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/indexShipmentlLeaderWin",
    name: "rhBigScreenIndexShipmentlLeaderWin",
    component: () => import("../IndexShipmentlLeaderWin.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/IndexShipmentlLeaderWinShowP",
    name: "rhBigScreenIndexShipmentlLeaderWinShowP",
    component: () => import("../IndexShipmentlLeaderWinShowP.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/IndexShipmentlLeaderWinChange",
    name: "rhBigScreenIndexShipmentlLeaderWinChange",
    component: () => import("../IndexShipmentlLeaderWinChange.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/intoPage",
    name: "rhBigScreenintoPage",
    component: () => import("../IntoPage.vue"),
    meta: {
      title: defaultTitle
    }
  },
  {
    path: "/rhBigScreen/devicePage",
    name: "rhBigScreendevicePage",
    component: () => import("../devicePage.vue"),
    meta: {
      title: defaultTitle
    }
  }
];
export default routes;
